export default {
    Profile: {
        target: "Mục tiêu",
        ports: "Cổng",
        created: "Ngày tạo",
        finished: 'Thực hiện xong',
        status: 'Trạng thái',
        action: 'Thao tác',
        SearchEmptyText: 'Tìm theo mục tiêu, cổng'
    },
    Poc: {
        ip: "Mục tiêu",
        port: "Cổng",
        cve: "Cve",
        created: "Ngày tạo",
        finished: 'Thực hiện xong',
        status: 'Trạng thái',
        action: 'Thao tác',
        command: 'Tùy chỉnh lệnh',
        SearchEmptyText: 'Tìm theo mục tiêu, cổng'
    }
};  
